import { render, staticRenderFns } from "./QuotationData.html?vue&type=template&id=3b51a4bb&"
import script from "./QuotationData.js?vue&type=script&lang=js&"
export * from "./QuotationData.js?vue&type=script&lang=js&"
import style0 from "./QuotationData.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports